import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const SourceIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.3431 5.29289L20.7071 11.6569C21.0976 12.0474 21.0976 12.6805 20.7071 13.0711L14.3431 19.435C13.9526 19.8256 13.3195 19.8256 12.9289 19.435C12.5384 19.0445 12.5384 18.4113 12.9289 18.0208L17.5858 13.364H4C3.44772 13.364 3 12.9162 3 12.364C3 11.8117 3.44772 11.364 4 11.364H17.5858L12.9289 6.70711C12.5384 6.31658 12.5384 5.68342 12.9289 5.29289C13.3195 4.90237 13.9526 4.90237 14.3431 5.29289Z'
                fill='currentColor'
            />
        </>
    ),
})

SourceIcon.displayName = 'SourceIcon'
